<template>
  <div>
    <v-row class='pt-4 pb-5 d-flex justify-center align-center'>
      <v-col cols="12" class="text-center" style="text-align-last: center;">
        <input-number
          format="decimal"
          required
          solo
          flat
          value-when-is-empty="0,00"
          class="centered-input vlrSelecionado"
          style="font-size: 36px; font-weight: 500; line-height: 42px; letter-spacing: normal; color: var(--v-primary-base)"
          v-model="model"
          @input="inputVal"
          :min="min"
          :max="max"
          :custom-rule="model > 0"
          custom-error="Informe o valor do empréstimo"
          :outlined="false">
        </input-number>
        <template>
          <div>
            <span class="text-caption">{{ msg }}</span>
          </div>
        </template>
      </v-col>
    </v-row>
    <v-row>
          <v-slider @mousedown="stepInterno = step" @input="inputSlider" class="mglu-slider" hide-details :value="model" :error="model > max" track-color="secondary" :min="min" :max="max" thumb-label="always" thumb-size="1" :step="stepInterno && stepInterno > model ? min : stepInterno">
            <template slot="thumb-label">
              <v-img style="top: 14px;"
                     src="assets/icons/slider.svg"
                     max-width="64"
                     max-height="64"
                     alt="Ícone" />
            </template>
          </v-slider>
    </v-row>
    <v-row class='d-flex justify-end align-center'>
      <v-col cols="6" class="pt-0 pb-3 text-left">
        <span bold>
          R$ {{$api.UI.Format.Decimal(min)}}
        </span>
      </v-col>
      <v-col cols="6" class="pt-0 pb-3 text-right">
        <span bold>
          R$ {{ $api.UI.Format.Decimal(max) }}
        </span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    min: Number,
    max: Number,
    value: Number,
    limite: null,
    step: { type: Number, default: 0 }
  },
  data () {
    return {
      valorSliderSelecionado: 0,
      stepInterno: null,
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    msg () {
      if (this.model > this.limite) {
        return 'O valor solicitado é maior que o limite Pré-aprovado'
      }
      return 'ㅤ'
    },
  },
  methods: {
    ruleVlrSolicitado () {
      if (this.model < this.min) {
        return [this.model > this.min || 'Valor informado é menor que o valor mínimo']
      } else if (this.model < 0) {
        return [this.model > 0 || 'Informe o valor do empréstimo']
      }
    },
    inputSlider (value) {
      if (!this.controlValue && value !== this.model) {
        this.$set(this, 'model', value)
      }
    },
    inputVal (value) {
      if (value !== this.valorSliderSelecionado) {
        this.controlValue = true
        this.$set(this, 'valorSliderSelecionado', value)
      }
      setTimeout(() => { this.controlValue = false }, 100)
    },
    change (value) {
      this.$emit('change', value)
    }
  },
  mounted () {
    this.$emit('mounted')
  }
}
</script>
